import React, { useState, useContext, useEffect } from 'react';
import { Button, Modal }      from 'react-bootstrap';
import { AuthContext } from './AuthContext';

const LoginModal = ({ isOpen, onClose }) => {
  const [email,          setEmail] = useState('');
  const [password,       setPassword] = useState('');
  const [message,        setMessage]  = useState('');
  const [errState,       setErrState] = useState( false );
  const [forgotPassword, setForgotPassword] = useState(false);
  const { login, resetPassword } = useContext(AuthContext);
  
  const handleLogin = async () => {
    // Call login API provided by AuthContext
    const response = await login( email, password );
    if (response.success) {
        onClose( true ); // Close the modal after login
    } else {
        setErrState( true );
        setMessage( "Login failed: " + response.message );
    }
  };

 const handleReset = async () => {
    // Call login API provided by AuthContext
    const response = await resetPassword( email );
    if (response.success) {
        onClose( false ); // Close the modal after login
    } else {
        setErrState( true );
        setMessage( "Reset failed: " + response.message );
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Enter') {
        // Trigger the login button click when Enter is pressed
        if ( !forgotPassword ) {
            handleLogin();
        } else {
            handleReset();
        }
      }
    };

    // Add event listener for 'Enter' key press
    document.addEventListener('keydown', handleKeyPress);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [email, password]); // Add dependencies to reset key event listeners when inputs change
  
  function backToLogin() {
      setForgotPassword(false);
  }
 
  function passwordResetRequest() {
       setForgotPassword(true);
  }
  
  if (!isOpen) return null; // Don't render the modal if it's not open

  return (<>
    { forgotPassword ? (
    <Modal show={ true } backdrop="static">
      <Modal.Header><Modal.Title>Reset Password</Modal.Title></Modal.Header>
      <Modal.Body>
        <p>Enter your email address. If it is registered, you will receive a password reset link via email.</p>
        <form>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" size="sm" onClick={handleReset}>Reset Password</Button>
        <Button variant="primary" size="sm" onClick={onClose}>Close</Button>
        <p><a onClick={backToLogin}>Back to login</a></p>
        <p>{ message }</p>
      </Modal.Footer>
    </Modal>
    ) : (
    <Modal show={ true } backdrop="static">
      <Modal.Header><Modal.Title>Login</Modal.Title></Modal.Header>
      <Modal.Body>
        <form>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" size="sm" onClick={handleLogin}>Login</Button>
        <Button variant="primary" size="sm" onClick={() => onClose( false )}>Close</Button>
        <p><a onClick={passwordResetRequest}>Reset password</a></p>
        <p className={"message-err-" + errState}>{ message }</p>
      </Modal.Footer>
    </Modal>
    )}
    </>
  );
};

export default LoginModal;
